import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TextField, Box, Button, Container, Typography, Modal, Paper, Tooltip } from '@mui/material';

const EditDepartment = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [departmentName, setDepartmentName] = useState('');
  const { deptId } = useParams();
  const navigate = useNavigate();

  // Static data for departments
  const staticDepartmentData = [
    { deptId: 1, departmentName: 'Administration' },
    { deptId: 2, departmentName: 'Finance' },
    { deptId: 3, departmentName: 'IT' },
    { deptId: 4, departmentName: 'Management' },
    { deptId: 5, departmentName: 'Marketing' },
    { deptId: 6, departmentName: 'Reception' },
    { deptId: 7, departmentName: 'Sales' },
    { deptId: 8, departmentName: 'Teaching' },
  ];

  useEffect(() => {
  const deptIdInt = parseInt(deptId, 10); // Ensure deptId is parsed as an integer
  const department = staticDepartmentData.find(dept => dept.deptId === deptIdInt);

  console.log('deptId from URL:', deptIdInt); // Debugging log
  console.log('Department IDs in static data:', staticDepartmentData.map(dept => dept.deptId)); // Debugging log

  if (department) {
    setDepartmentName(department.departmentName);
  } else {
    alert('Department not found');
  }
}, [deptId]);


  const handleUpdate = () => {
    if (departmentName.trim()) {
      setShowSuccessModal(true);
    } else {
      alert('Please enter a department name');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Department
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <TextField
            label="Department Name"
            variant="outlined"
            fullWidth
            value={departmentName}
            onChange={(e) => setDepartmentName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!departmentName && "Enter Department Name"} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleUpdate}
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!departmentName}
              >
                Update
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
           data-app-cancel="true">
            Cancel
          </Button>
        </div>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Department Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Department Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditDepartment;
